import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Link from '@material-ui/core/Link';
import Checkbox from '@material-ui/core/Checkbox';
import ItecDialog from '../../../modules/checkListGenerator/itechChecklist/itechAddRelevancePopUp';

// import ButtonComp from '../../button';
// import './styles.css';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     display: 'flex',
    //     flexWrap: 'wrap',
    // },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    button: {
        margin: '10px 0px 5px !important',
        width: '155px',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    toggleCss: {
        marginLeft: '0',
        marginRight: '0',
    },
    chekListAddBtn: {
        marginLeft: '20px',
        borderColor: '#5a58b1',
        color: '#5a58b1',
        borderRadius: '5px',
        width: '100px',
        padding: '5px',
        background: 'transparent',
    },
}));

export default function ItechBankDetails() {
    const [checked, setChecked] = React.useState(false);
    const [itecOpen, setItecOpen] = React.useState(false);
    const [state, setState] = React.useState({
        checkedName: true,
        checkedAccNo: true,
    });

    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };

    const handleChangeToggle = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };

    const toggleChecked = () => {
        setChecked((prev) => !prev);
    };
    const classes = useStyles();
    const [formvalues, setformValues] = React.useState({
        bankName: 'Enter Bank Name',
        accno: 'Enter Account Number',
        ifscCode: 'Enter IFSC Code',
        typeOfAcc: 'Select Type of Account',
        jointAccHolName: 'Enter Joint Account Holder Name',
    });

    // const handleChange = (prop) => (event) => {
    //     setValues({ ...values, [prop]: event.target.value });
    // };

    // const handleClickShowPassword = () => {
    //     setValues({ ...values, showPassword: !values.showPassword });
    // };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleRelevence = () => {
        //console.log('handleRele++++');
        setItecOpen(true);
    };
    const handleItecClose = () => {
        setItecOpen(false);
    };
    return (
        <>
            <Grid container spacing={3} className="main-container">
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin}>
                        <InputLabel htmlFor="bank-name">Bank Name</InputLabel>
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="bank-name"
                            value={formvalues.bankName}
                        // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin}>
                        <InputLabel htmlFor="Account-number">Account Number</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="Account-number"
                            value={formvalues.accno}
                        // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin}>
                        <InputLabel htmlFor="Ifsc-code">IFSC Code</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="Ifsc-code"
                            value={formvalues.ifscCode}
                        // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin}>
                        <InputLabel htmlFor="type-of-account">Type of account</InputLabel>
                        <Select
                            native
                            // value={state.year}
                            onChange={handleChange}
                            inputProps={{
                                name: 'Type of Account',
                            }}
                            className={classes.bottomLine}
                        >
                            <option aria-label="None" value="Select Account Type" />
                            <option value={10}>Savings</option>
                            <option value={20}>Current</option>
                        </Select>
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={() => handleRelevence('accType')}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin}>
                        <InputLabel htmlFor="Joint-Account-Holder-Name">Name of joint account holder, if any</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="Joint-Account-Holder-Name"
                            value={formvalues.jointAccHolName}
                        // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="w100" style={{ marginTop: '21px' }}>
                        <AttachFileIcon />
                        <Link
                            underline="always"
                            component="a"
                            className={classes.linkview}
                            color="primary"
                            variant="body2"
                            onClick={() => {
                                // alert("I'm a button.");
                            }}
                        >
                            View Bank Statement
                        </Link>
                    </div>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        className={classes.button}
                        startIcon={<InsertCommentIcon />}
                        onClick={() => handleRelevence('viewbankstatement')}
                    >
                        Add Relevance
                    </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControlLabel
                        control={<Checkbox checked={state.checkedA} onChange={handleChange} name="checkedA" color="primary" />}
                        label="Preferred bank account for credit of refund"
                    />
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        className={classes.button}
                        startIcon={<InsertCommentIcon />}
                        onClick={() => handleRelevence('preferredbank')}
                    >
                        Add Relevance
                    </Button>
                </Grid>
            </Grid>
            {itecOpen && <ItecDialog itecOpen={itecOpen} handleItecClose={handleItecClose} />}
        </>
    );
}
